window.addEventListener('load', function () {
  const klaviyo = window.klaviyo || []

  klaviyo.init({
    account: window.__GLOBAL__.klaviyoPublicKey,
    platform: 'shopify'
  })

  klaviyo.enable('backinstock', {
    trigger: {
      product_page_text: 'Notify Me When Available',
      product_page_class: 'button',
      product_page_text_align: 'center',
      product_page_margin: '24px 0px 0px',
      alternate_anchor: 'product-submit-button',
      replace_anchor: false
    },
    modal: {
      headline: '{product_name}',
      body_content: 'Register to receive a notification when this item comes back in stock.',
      email_field_label: 'Email',
      button_label: 'Notify me when available',
      subscription_success_label: "You're in! We'll let you know when it's back.",
      additional_styles: `@import url('${window.__GLOBAL__.klaviyoAdditionalScript}');`,
      footer_content: '',
      drop_background_color: '#000',
      background_color: '#fff',
      text_color: '#57636c',
      button_text_color: '#fff',
      button_background_color: '#57636c',
      close_button_color: '#ccc',
      error_background_color: '#fcd6d7',
      error_text_color: '#C72E2F',
      success_background_color: '#d3efcd',
      success_text_color: '#1B9500'
    }
  })

  // Helper function to extract form data and email
  function extractFormData(form: HTMLFormElement): { formData: Record<string, string>; email: string } {
    const data = new FormData(form)
    const formData: Record<string, string> = {}
    let email = ''

    for (const [key, value] of data.entries()) {
      const val = value.toString()
      const matched = key.match(/^contact(?:\[([^\]]+)\])(?:\[([^\]]+)\])?/)

      if (matched) {
        const field = matched[1]
        const subField = matched[2]

        if (subField) {
          const combinedKey = `${field}_${subField}`

          formData[combinedKey] = val
        } else if (field) {
          formData[field] = val
        }
      } else {
        formData[key] = val
      }

      if (!email && key.toLowerCase().includes('email')) {
        email = val
      }
    }

    return { formData, email }
  }

  const forms = document.querySelectorAll('.js-contact-form')

  if (forms.length) {
    forms.forEach((formElement) => {
      formElement.addEventListener('submit', function () {
        const form = formElement as HTMLFormElement

        // Only proceed if Klaviyo is available
        if (!klaviyo) return

        const { formData, email } = extractFormData(form)

        // Only proceed with tracking if we have an email

        if (!email) {
          // eslint-disable-next-line
          console.warn('Klaviyo tracking: No email field found in form submission')

          return
        }

        const callbackFn = () => {
          try {
            klaviyo.track('Form Submission', formData)
          } catch (error) {
            // eslint-disable-next-line
            console.error('Failed to track form submission:', error)
          }
        }

        try {
          klaviyo.identify({ email: email }, callbackFn)
        } catch (error) {
          // eslint-disable-next-line
          console.error('Failed to identify user with Klaviyo:', error)
        }
      })
    })
  }
})
